export default __webpack_public_path__ + "static/pezlarova-735b25a402b0e98a8ddb4125b0a38633.jpg";